export { CopyJob } from './copy-job';
import { CopyJob } from './copy-job';
import { CopyJobProvider } from './copy-job.provider';

export const FeatureCopyJob = () => {
   return (
      <CopyJobProvider>
         <CopyJob></CopyJob>
      </CopyJobProvider>
   );
};
